var React = require('react');

function OneLight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M27.839 3.875a4.862 4.862 0 00-5.91-.22l-13.56 9.614a.337.337 0 00-.127.374l2.446 7.913L17.4 16.7a1 1 0 011.587.81v26.53l9.55 1.082V5.356a1.92 1.92 0 00-.697-1.481zm2.697 41.036L35 43.619V13.404a7 7 0 00-2.33-5.215l-2.134-1.91v38.632zM29.221 2.426a6.862 6.862 0 00-8.45-.402l-13.56 9.613a2.337 2.337 0 00-.88 2.597l2.859 9.245a1 1 0 00.672.664l7.124 2.098v18.69a1 1 0 00.887.995l11.55 1.308a1 1 0 00.391-.032l6.464-1.87A1 1 0 0037 44.37V13.404A9 9 0 0034.004 6.7l-4.695-4.203a1.014 1.014 0 00-.088-.07zm-12.235 21.73v-4.689L12.38 22.8l4.605 1.356z"}));
}

OneLight.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = OneLight;

OneLight.default = OneLight;
